import { render, staticRenderFns } from "./data-packaging-page.vue?vue&type=template&id=26fc0e5d&scoped=true"
import script from "./data-packaging-page.vue?vue&type=script&lang=js"
export * from "./data-packaging-page.vue?vue&type=script&lang=js"
import style0 from "./data-packaging-page.vue?vue&type=style&index=0&id=26fc0e5d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26fc0e5d",
  null
  
)

export default component.exports